define(['../models/QuickQuoteTile', 'text!./templates/pa-quick-quote-tile.html'], (quickQuoteTile, template) =>[() => ({
    'restrict': 'A',
    template,
    'scope': {
        'tileModel': '=gwPaQuickQuoteTile',
        'previousTileModel': '=gwPaQuickQuotePreviousModel',
        'preQuoteFn': '&',
        'panelsValid': '=',
        'transitionQuoteToEdit': '=',
        'transitionQuoteToQuoted': '='
    },
    controller: ['$scope', 'quickquote.QuickQuoteService', ($scope, QuickQuoteService) => {
        $scope.model = quickQuoteTile(QuickQuoteService, $scope.tileModel, $scope.previousTileModel);
        $scope.tileModel.actions.setStarQuotingFn($scope.model.startQuoting);

        $scope.panelsValid.isValid = () => $scope.tileModel.viewModel.aspects.valid && $scope.tileModel.viewModel.aspects.subtreeValid && $scope.tileModel.viewModel.quotedSubmission;

        $scope.transitionQuoteToEdit = () => {
            $scope.model.state.data.onRevise();
        };

        $scope.transitionQuoteToQuoted = () => {
            $scope.model.startQuoting();
        };

        $scope.$watch('model.state.id', (newState, oldState)=> {
            if (newState === 'proceedToFullQuote') {
                $scope.tileModel.actions.proceedToFullQuote();
            }
            if (newState !== 'edit' && newState !== 'quoteError') {
                $scope.tileModel.actions.setLocked(true);
            } else {
                $scope.tileModel.actions.setLocked(false);
            }

            if (newState === 'edit' && oldState === 'quoted') {
                $scope.tileModel.actions.reviseQuote();
            }
        });
    }]
})]);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/quote/directives/PAQuickQuoteTile.js
 **/